module.exports = __webpack_public_path__ + "img/downBanner.739223bb.jpg";